<template>
  <div class="add-black-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <el-form-item label="快捷回复:" prop="replay">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="params.replay"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      // 请求参数
      params: {
        id: "",
        replay: "",
      },
      // 表单验证规则
      rules: {
        replay: [{ message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.upDate();
        } else {
          return false;
        }
      });
    },
    // 编辑标签
    upDate() {
      API.updateFeedback(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerAddblack");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: "",
        replay: "",
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true;
      this.title = "编辑用户反馈";
      this.params = row;
    },
  },
};
</script>

<style lang="scss" >
</style>
